import type { ISiteSettings } from '@sravni/types/lib/sitesettings';

export const DEFAULT_SITE_SETTINGS: ISiteSettings = {
  header: {
    menu: [
      {
        text: 'Карты',
        href: '',
        noindex: false,
        nofollow: false,
        isLink: false,
        children: [
          {
            text: 'Кредитные карты',
            href: '/karty/',
            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Дебетовые карты',
            href: '/debetovye-karty/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
        ],
      },
      {
        text: 'Кредиты',
        href: '',

        noindex: false,
        nofollow: false,
        isLink: false,
        children: [
          {
            text: 'Персональный подбор кредита',
            href: '/kredity/onlajn-zayavka-na-kredit/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Кредитный рейтинг',
            href: '/kredity/scoring/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Кредиты под залог',
            href: 'https://www.sravni.ru/kredity/pod-zalog/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Потребительские кредиты',
            href: '/kredity/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Автокредиты',
            href: '/avtokredity/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Микрозаймы',
            href: '/zaimy/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
        ],
      },
      {
        text: 'Ипотека',
        href: '/ipoteka/',

        noindex: false,
        nofollow: false,
        isLink: true,
        children: [
          {
            text: 'Новостройки',
            href: '/ipoteka/zhile-na-pervichnom-rynke/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Вторичка',
            href: '/ipoteka/zhile-na-vtorichnom-rynke/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Рефинансирование',
            href: '/ipoteka/refinansirovanie-ipoteki/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Без первоначального взноса',
            href: '/ipoteka/bez-pervonachalnogo-vznosa/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Ипотечное страхование',
            href: 'https://www.sravni.ru/strahovanie-ipoteki/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
        ],
      },
      {
        text: 'Вклады',
        href: '/vklady/',

        noindex: false,
        nofollow: false,
        isLink: true,
        children: [],
      },
      {
        text: 'Страхование',
        href: '',

        noindex: false,
        nofollow: false,
        isLink: false,
        children: [
          {
            text: 'ОСАГО',
            href: '/osago/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'КАСКО',
            href: '/kasko/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Страхование путешественников',
            href: '/vzr/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Страхование ипотеки',
            href: '/strahovanie-ipoteki/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Страхование недвижимости',
            href: '/strahovanie-nedvizhimosti/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Страхование от коронавируса',
            href: '/promo/strahovanie-ot-koronavirusa/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
        ],
      },
      {
        text: 'Журнал',
        href: '',

        noindex: false,
        nofollow: false,
        isLink: false,
        children: [
          {
            text: 'Статьи и новости',
            href: '/mag/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [
              {
                text: 'Сравнения',
                href: '/mag/rubrika/sravnenia/',

                noindex: false,
                nofollow: false,
                isLink: true,
                children: [],
              },
              {
                text: 'Бытовая аналитика',
                href: '/mag/rubrika/bytovaja-analitika/',

                noindex: false,
                nofollow: false,
                isLink: true,
                children: [],
              },
              {
                text: 'Тест-драйвы',
                href: '/mag/rubrika/test-draivy/',

                noindex: false,
                nofollow: false,
                isLink: true,
                children: [],
              },
              {
                text: 'Истории',
                href: '/mag/rubrika/istorii/',

                noindex: false,
                nofollow: false,
                isLink: true,
                children: [],
              },
              {
                text: 'Советы',
                href: '/mag/rubrika/sovety/',

                noindex: false,
                nofollow: false,
                isLink: true,
                children: [],
              },
              {
                text: 'Новости партнеров',
                href: '/mag/rubrika/mag-partnerov/',

                noindex: false,
                nofollow: false,
                isLink: true,
                children: [],
              },
              {
                text: 'Funny Money',
                href: '/mag/rubrika/funnymoney/',

                noindex: false,
                nofollow: false,
                isLink: true,
                children: [],
              },
            ],
          },
          {
            text: 'Сервисы',
            href: '',

            noindex: false,
            nofollow: false,
            isLink: false,
            children: [
              {
                text: 'Вопрос-ответ',
                href: '/q/',

                noindex: false,
                nofollow: false,
                isLink: true,
                children: [],
              },
              {
                text: 'Перевод с карты на карту',
                href: '/perevod-s-karty-na-kartu/',

                noindex: false,
                nofollow: false,
                isLink: true,
                children: [],
              },
              {
                text: 'Проверка КБМ',
                href: '/osago/proverka-kbm/',

                noindex: false,
                nofollow: false,
                isLink: true,
                children: [],
              },
              {
                text: 'РКО',
                href: '/rko/tarify/',

                noindex: false,
                nofollow: false,
                isLink: true,
                children: [],
              },
            ],
          },
        ],
      },
    ],
    mobileMenu: [
      {
        text: 'Деньги',
        href: '',

        noindex: false,
        nofollow: false,
        isLink: false,
        children: [
          {
            text: 'Вклады',
            href: '/vklady/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Персональный подбор кредита',
            href: '/kredity/onlajn-zayavka-na-kredit/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Кредитный рейтинг',
            href: 'https://www.sravni.ru/kredity/scoring/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Кредиты',
            href: '/kredity/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Кредиты под залог',
            href: 'https://www.sravni.ru/kredity/pod-zalog/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Ипотека',
            href: '/ipoteka/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Автокредиты',
            href: '/avtokredity/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Микрозаймы',
            href: '/zaimy/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Кредитные карты',
            href: '/karty/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Дебетовые карты',
            href: '/debetovye-karty/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'РКО',
            href: '/rko/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
        ],
      },
      {
        text: 'Страховки',
        href: '',

        noindex: false,
        nofollow: false,
        isLink: false,
        children: [
          {
            text: 'ОСАГО',
            href: '/osago/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'КАСКО',
            href: '/kasko/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Страхование путешественников',
            href: '/vzr/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Страхование ипотеки',
            href: '/strahovanie-ipoteki/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Страхование недвижимости',
            href: '/strahovanie-nedvizhimosti/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Страхование от коронавируса',
            href: '/promo/strahovanie-ot-koronavirusa/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
        ],
      },
      {
        text: 'Банки ',
        href: '',

        noindex: false,
        nofollow: false,
        isLink: false,
        children: [
          {
            text: 'Банки России',
            href: '/banki/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Отзывы',
            href: '/banki/otzyvy/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Рейтинги',
            href: '/banki/rating/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Курсы валют ЦБ РФ',
            href: '/valjuty/kursy-valjut-cb-rf/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Курсы обмена валют',
            href: '/valjuty/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
        ],
      },
      {
        text: 'Страховые компании',
        href: '',

        noindex: false,
        nofollow: false,
        isLink: false,
        children: [
          {
            text: 'Страховые компании',
            href: '/strakhovye-kompanii/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Отзывы',
            href: '/strakhovye-kompanii/otzyvy/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Рейтинги',
            href: '/strakhovye-kompanii/rating/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
        ],
      },
      {
        text: 'Финансовые советы',
        href: '',

        noindex: false,
        nofollow: false,
        isLink: false,
        children: [
          {
            text: 'Статьи и новости',
            href: '/mag/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Сравнения',
            href: '/mag/rubrika/sravnenia/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Бытовая аналитика',
            href: '/mag/rubrika/bytovaja-analitika/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Тест-драйвы',
            href: '/mag/rubrika/test-draivy/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Истории',
            href: '/mag/rubrika/istorii/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Советы',
            href: '/mag/rubrika/sovety/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Funny Money',
            href: '/mag/rubrika/funnymoney/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
        ],
      },
      {
        text: 'Сервисы',
        href: '',

        noindex: false,
        nofollow: false,
        isLink: false,
        children: [
          {
            text: 'Вопрос-ответ',
            href: '/q/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Перевод с карты на карту',
            href: '/perevod-s-karty-na-kartu/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Проверка КБМ',
            href: '/osago/proverka-kbm/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'РКО',
            href: '/rko/tarify/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
        ],
      },
    ],
  },
  footer: {
    socialLinks: undefined,
    support: undefined,
    menu: [
      {
        text: '',
        href: '',

        noindex: false,
        nofollow: false,
        isLink: false,
        children: [
          {
            text: 'О проекте',
            href: '/about/',

            noindex: true,
            nofollow: true,
            isLink: true,
            children: [],
          },
          {
            text: 'Контакты',
            href: '/about/#contacts',
            noindex: true,
            nofollow: true,
            isLink: true,
            children: [],
          },
          {
            text: 'Партнерская программа',
            href: '//partner2.sravni.ru/',
            noindex: true,
            nofollow: true,
            isLink: true,
            children: [],
          },
          {
            text: 'Для агентов',
            href: 'https://sravni-labs.ru/start/',
            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Политика конфиденциальности',
            href: '/about/privacy-policy/',
            noindex: true,
            nofollow: true,
            isLink: true,
            children: [],
          },
          {
            text: 'Энциклопедия',
            href: '/enciklopediya/',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Карта сайта',
            href: '/karta-sajta/',
            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
          {
            text: 'Наши вакансии',
            href: 'https://tech.sravni.ru',

            noindex: false,
            nofollow: false,
            isLink: true,
            children: [],
          },
        ],
      },
    ],
  },
};

export const AB_NAME = 'AB_NEWS';
